import { ReactNode, ReactHTML } from 'react';
import Text from '@ux/text';
import '@ux/text/styles';

import { textContainerClass } from './Typography.css';

export type EmphasisOptions =
  | 'critical'
  | 'success'
  | 'warning'
  | 'info'
  | 'highlight'
  | 'neutral'
  | 'internal'
  | 'passive'
  | 'premium';

export type TitleOptions = 'title' | 'heading' | 'paragraph' | 'action' | 'input' | 'label' | 'caption';
export type TypographySize = -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5;
type Props = {
  component: keyof ReactHTML;
  text: ReactNode;
  as?: TitleOptions;
  size?: TypographySize;
  emphasis?: EmphasisOptions;
  textContainerAs?: keyof ReactHTML;
  id?: string;
  'data-cy'?: string;
  className?: string;
};

export default function Typography({ component, textContainerAs, ...rest }: Readonly<Props>): JSX.Element {
  const TextComponent = Text[component];
  const Container = textContainerAs ?? 'div';

  return (
    <Container className={textContainerClass}>
      <TextComponent {...rest} />
    </Container>
  );
}
